export interface WorkPatternSet {
    wrkptnset_id: number
    begin_date?: Date
    end_date?: Date
}
export interface WorkPatternSetProps {
    wrkptnset_id: number | string
    begin_date?: string | null
    end_date?: string | null
}
export const ObjectToWorkPatternSet = (obj: WorkPatternSetProps): WorkPatternSet => {
    return {
        wrkptnset_id: typeof obj.wrkptnset_id == 'number' ? obj.wrkptnset_id : parseInt(obj.wrkptnset_id),
        begin_date: obj.begin_date ? new Date(obj.begin_date) : undefined,
        end_date: obj.end_date ? new Date(obj.end_date) : undefined,
    }
}